import { dec, formatMoney } from './money.js';
export const DEBT_KINDS = ['CHARGE', 'REPAYMENT'];
/**
 * The signed effect of a live debt movement on the debtor's stored balance:
 * a charge adds its final total, a repayment subtracts its amount (fuel.md
 * section 2). Deleting a movement applies the negation; restoring re-applies it.
 */
export function balanceEffect(kind, finalTotal) {
    const amount = dec(finalTotal);
    return formatMoney(kind === 'CHARGE' ? amount : amount.negated());
}
/**
 * The legacy debt-limit rule, applied to new charges only:
 * refuse when balance + finalTotal > debtLimit (DebtSaleController.php:213).
 */
export function exceedsDebtLimit(balance, finalTotal, debtLimit) {
    return dec(balance).plus(dec(finalTotal)).gt(dec(debtLimit));
}
/** Balance after applying a signed amount (movement effect or manual adjustment). */
export function applyToBalance(balance, signedAmount) {
    return formatMoney(dec(balance).plus(dec(signedAmount)));
}
/**
 * Debt list totals (fixes legacy defect 22): charges and repayments are
 * summed separately and the balance is charges − repayments.
 */
export function debtTotals(rows) {
    let charges = dec('0');
    let repayments = dec('0');
    for (const row of rows) {
        if (row.kind === 'CHARGE')
            charges = charges.plus(dec(row.finalTotal));
        else
            repayments = repayments.plus(dec(row.finalTotal));
    }
    return {
        charges: formatMoney(charges),
        repayments: formatMoney(repayments),
        balance: formatMoney(charges.minus(repayments)),
    };
}
//# sourceMappingURL=debt.js.map